/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import { findACouponCategoryOrMakeOne } from '@/model/dataLayer/api/buffet/buffetApis'
import GlobalSettings from '@/model/global/GlobalSettings'
import StringEntity from '@/model/dataLayer/api/common/StringEntity'
import dayjs from 'dayjs'
import Dish, { loadAllCode } from '@/model/dataLayer/api/dish/Dish'
import i18n from '@/i18n'

const entity = {
  price: {
    type: IKDataEntity.Types.Float,
    formConfig: {
      default: '',
      overwriteRule: true,
      rule: [
        v => /^[0-9]+\.{0,1}[0-9]{0,2}$/.test(v) || i18n.t('pls_enter_the_correct_price')
      ],
      hint: 'priceIsCouponBalance'
    },

    header: false
  },
  code: {
    tableConfig: {
      width: '160'
    },
    formConfig: {
      unique: true,
      uniqueTrackingList: Dish.getList,
      hint: 'EACouponRule'
    }
  },
  langs: {
    displayName: 'name',
    type: IKDataEntity.Types.Group,
    formConfig: {
      groupName: 'product_info', // 产品信息
      default: GlobalSettings.supportLang,
      childLabelKey: 'lang',
      type: {}
    },
    tableConfig: {
      displayCondition: (item) => {
        return item.lang.toLowerCase() === GlobalSettings.getLang().toLowerCase()
      },
      displayChild: (key) => {
        return key === 'name'
      }
    },
    childKey: ['name', 'desc'],
    labelKey: 'lang',
    children: [
      StringEntity, StringEntity, StringEntity
    ],
    header: false
  }
}
const config = {
  load: async function () {
    return (await hillo.get('Dishes.php?op=showCoupons', { lang: GlobalSettings.getLang() })).content.map(item => {
      item.langs.map(it => {
        it.desc = it.description
        return it
      })
      item.id = item.dishId
      return item
    })
  },
  add: async function (item) {
    item.printGroupId = 10
    item.isActive = 1
    item.categoryId = (await findACouponCategoryOrMakeOne()).id
    item.attributeGroup = ''
    item.allergenGroup = ''
    item.extraPrintGroupIds = ''
    if (item.code === '自动生成') {
      const codes = await loadAllCode()
      for (let i = 0; i < 10000; i++) {
        if (!codes.includes(i.toString())) {
          item.code = i
        }
      }
      if (item.code === '自动生成') {
        item.code = dayjs().utcOffset()
      }
    }
    return (await hillo.postWithUploadFile('Dishes.php?op=add', {
      ...item,
      params: JSON.stringify(item)
    }, { showLoading: true })).content
  },
  edit: async function (item) {
    return (await hillo.postWithUploadFile('Dishes.php?op=update', {
      ...item,
      params: JSON.stringify(item)
    }))
  },
  remove: async function (id) {
    try {
      await hillo.post('Dishes.php?op=delete', { id }, { silent: true })
    } catch (e) {
      await hillo.post('Dishes.php?op=softDelete', { id }, { silent: true })
    }
    return true
  }
}

export default IKDataEntity.ModelFactory(entity, config)
